import OliverText from "@builder/components/general/OliverText";
import { useOutsideClick } from "@builder/hooks/useOutsideClick";
import { useRef, useState } from "react";
import "./style.scss";

interface AdvSelectInputProps<T> {
    value?: T;
    options: T[];
    inputValue: string;
    label?: string;
    placeholder?: string;
    disabled?: boolean;
    hasMore: boolean;
    noSearch?: boolean;
    // matchOption: (option: T, value: T) => boolean;
    findLabel: (option: T) => string;
    clickCallback: (option: T) => void;
    scrollCallback: () => void;
    searchCallback: (value: string) => void;
    height?: string;
}

const AdvSelectInput = <T,>({
    value,
    options,
    inputValue,
    label,
    placeholder,
    disabled,
    hasMore,
    noSearch,
    // matchOption,
    findLabel,
    clickCallback,
    scrollCallback,
    searchCallback,
    height
}: AdvSelectInputProps<T>) => {
    const [open, setOpen] = useState<boolean>(false);
    const [searching, setSearching] = useState<boolean>(false);
    const wrapperRef = useRef<HTMLDivElement>(null);
    const scrollRef = useRef<HTMLDivElement>(null);

    useOutsideClick(wrapperRef, () => {
        setOpen(false);
        setSearching(false);
        searchCallback("");
    });

    const handleScroll = () => {
        const { scrollTop, clientHeight, scrollHeight } = scrollRef.current as HTMLElement;
        if (scrollTop + clientHeight >= scrollHeight - 10) {
            scrollCallback();
        }
    };

    const handleInputButton = () => {
        if (open) {
            searchCallback("");
            setOpen(false);
            setSearching(false);
        } else {
            setOpen(true);
        }
    };

    const handleOptionClick = (option: T) => {
        clickCallback(option);
        searchCallback("");
        setSearching(false);
        setOpen(false);
    };

    const inputWrapperStyle = height ? { height } : {};
    const optionStyle = height ? { height } : {};

    return (
        <div className="adv-select-input-wrapper" ref={wrapperRef}>
            {label && <OliverText size="xs" text={label} translatePrefix="generalComponents.advSelectInput." />}
            <div className={open ? "input-wrapper is-open" : "input-wrapper"} style={inputWrapperStyle}>
                <input
                    type="text"
                    placeholder={placeholder}
                    value={searching ? inputValue : value ? findLabel(value) : ""}
                    onFocus={() => {
                        if (!noSearch) {
                            setSearching(true);
                        }
                        setOpen(true);
                    }}
                    readOnly={noSearch}
                    onChange={(e: React.FormEvent<HTMLInputElement>) => {
                        searchCallback(e.currentTarget.value);
                    }}
                    disabled={disabled && !searching}
                />
                <button onClick={handleInputButton} disabled={disabled && !searching}>
                    <img src="./angled-arrow-down.svg" alt="" />
                </button>
                {open && (
                    <div className="options-wrapper" ref={scrollRef} onScroll={handleScroll}>
                        {options.map(option => {
                            if ((option as any)._id) {
                                return (
                                    <div className="option" style={optionStyle} key={(option as any)._id} onClick={() => handleOptionClick(option)}>
                                        <OliverText size="xs" text={findLabel(option)} />
                                    </div>
                                );
                            }
                        })}
                        {hasMore && (
                            <div className="option loading" style={optionStyle}>
                                <img src="/FinalLoader.gif" alt="" />
                            </div>
                        )}
                    </div>
                )}
            </div>
        </div>
    );
};

export default AdvSelectInput;
